/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Job_FailedInputs */

const en_ad_job_failed = /** @type {(inputs: Ad_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to submit Automatic AD job.`)
};

const fr_ad_job_failed = /** @type {(inputs: Ad_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la soumission de la tâche AD automatique.`)
};

const de_ad_job_failed = /** @type {(inputs: Ad_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatischer AD-Auftrag konnte nicht übermittelt werden.`)
};

const it_ad_job_failed = /** @type {(inputs: Ad_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile inviare il processo AD automatico.`)
};

const ru_ad_job_failed = /** @type {(inputs: Ad_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось отправить задание автоматической отправки в Active Directory.`)
};

const es_ad_job_failed = /** @type {(inputs: Ad_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo enviar la tarea automática de AD.`)
};

const zh_cn2_ad_job_failed = /** @type {(inputs: Ad_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动 AD 作业提交失败。`)
};

const ja_ad_job_failed = /** @type {(inputs: Ad_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動ADジョブの送信に失敗しました。`)
};

const hi_ad_job_failed = /** @type {(inputs: Ad_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित AD जॉब सबमिट करने में विफल।`)
};

const pt_pt2_ad_job_failed = /** @type {(inputs: Ad_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao enviar a tarefa automática do AD.`)
};

/**
* | output |
* | --- |
* | "Failed to submit Automatic AD job." |
*
* @param {Ad_Job_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_job_failed = /** @type {((inputs?: Ad_Job_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Job_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_job_failed(inputs)
	if (locale === "de") return de_ad_job_failed(inputs)
	if (locale === "it") return it_ad_job_failed(inputs)
	if (locale === "ru") return ru_ad_job_failed(inputs)
	if (locale === "es") return es_ad_job_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_job_failed(inputs)
	if (locale === "ja") return ja_ad_job_failed(inputs)
	if (locale === "hi") return hi_ad_job_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_job_failed(inputs)
	return en_ad_job_failed(inputs)
});